import React from 'react'
import styled from 'styled-components'
import PokeBall from './PokeBall'

const LivesContainer = styled.div`
    grid-area: 1 / 5 / 5 / 6;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 1rem;

    @media (max-width: 480px) {
      grid-area: 1;
    }
`

interface LivesProps {
  lives: number
  remainingLives: number
}

const Lives = ({ lives, remainingLives }: LivesProps): JSX.Element => {
  return (
        <LivesContainer>
            {
                Array(lives - remainingLives).fill(null).map((_, index) => {
                  return <PokeBall key={index} color='#5A5A5A' />
                })
            }
            {
                Array(remainingLives).fill(null).map((_, index) => {
                  return <PokeBall key={index} color='red' animation='alive' />
                })
            }
        </LivesContainer>
  )
}

export default Lives
